import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  Divider,
  Link
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { Google as GoogleIcon } from '@mui/icons-material';
import TivraLogo from '../assets/tivra_logo.svg';
import { Link as RouterLink } from 'react-router-dom';
import { loginUser } from '../services/authService'; // Import loginUser



export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Current auth state:', auth.currentUser);

    try {
      setError('');
      setLoading(true);
      await loginUser(email, password);

      setTimeout(() => {
        console.log('Auth state after login:', auth.currentUser);
        if (auth.currentUser) {
          navigate('/app');
        } else {
          console.error('No user after login');
        }
      }, 1000);
    } catch (error) {
      console.error('Login error:', error);
      setError('Failed to sign in. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      setLoading(true);
      await signInWithGoogle();
      navigate('/app');
    } catch (error) {
      console.error('Google sign in error:', error);
      setError('Failed to sign in with Google.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#F8F9FA',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <RouterLink to="/"> {/* Wrap the logo with RouterLink */}
          <img src={TivraLogo} alt="Tivra Logo" style={{ marginBottom: '20px', width: '200px' }} />
        </RouterLink>
      </Box>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 400,
          borderRadius: 2
        }}
      >

        <Typography
          variant="h5"
          sx={{
            mb: 3,
            fontWeight: 600,
            textAlign: 'center'
          }}
        >
          Sign In
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
            required
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 3 }}
            required
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{
              textTransform: 'none',
              py: 1.5,
              backgroundColor: '#2D68FE',
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>

        <Box sx={{ mt: 2, mb: 2 }}>
          <Divider>or</Divider>
        </Box>

        <Button
          onClick={handleGoogleSignIn}
          variant="outlined"
          fullWidth
          disabled={loading}
          startIcon={<GoogleIcon />}
          sx={{
            textTransform: 'none',
            py: 1.5,
            mb: 2
          }}
        >
          Sign in with Google
        </Button>

        <Box sx={{
          mt: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Link
            href="/signup"
            variant="body2"
            sx={{
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Create an account
          </Link>
          <Link
            href="/forgot-password"
            variant="body2"
            sx={{
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Forgot password?
          </Link>
        </Box>
      </Paper>
      <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
        <Link
          href="/privacy"
          variant="body2"
          sx={{
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >Privacy Policy </Link> | <Link
          href="/terms"
          variant="body2"
          sx={{
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >Terms of use </Link>
      </Typography>
    </Box>
  );
}
